import React, { useEffect, useState} from 'react';
import { Typography, Box } from '@material-ui/core';


const ClientInfo = (props) => {
    useEffect(() => {
        console.log("[DEBUG], ClientInfo",props.client)
    }, []);

    
    return (
        <Box>
            {/*test is client provenant d'une vente paygo ID"*/}
            {(props.client.client_paygo_id !== "") &&
            <>
            <Typography gutterBottom>
                <strong>PaygoID :</strong> {props.client.client_firstname}
                </Typography>
                <Typography gutterBottom>
                <strong>Nom :</strong> {props.client.client_lastname}
                </Typography>
                <Typography gutterBottom>
                <strong>Adress :</strong> {props.client.client_address}
                </Typography>
            </>}
            {/*test si client pro ou pass*/}
            {(props.client.client_paygo_id === "" && props.client.client_type === "professionnel") &&
            <>
            <Typography gutterBottom>
                <strong>Type :</strong> Professionel
                </Typography>
                <Typography gutterBottom>
                <strong>Nom Entreprise:</strong> {props.client.client_companyname}
                </Typography>
                <Typography gutterBottom>
                <strong>IFU :</strong> {props.client.client_ifu}
                </Typography>
                <Typography gutterBottom>
                <strong>RCCM :</strong> {props.client.client_rccm}
                </Typography>
                <Typography gutterBottom>
                <strong>Nom :</strong> {props.client.client_firstname}
                </Typography>
                <Typography gutterBottom>
                <strong>Prénom :</strong> {props.client.client_lastname}
                </Typography>
                <Typography gutterBottom>
                <strong>Téléphone :</strong> {props.client.client_tel}
                </Typography>
                <Typography gutterBottom>
                <strong>Adress :</strong> {props.client.client_address}
                </Typography>
                <Typography gutterBottom>
                <strong>Ville :</strong> {props.client.client_city}
                </Typography>
                <Typography gutterBottom>
                <strong>Pays :</strong> {props.client.client_country}
                </Typography>
            </>
            }
            {(props.client.client_paygo_id === "") && props.client.client_type !== "professionnel" &&
            <>
            <Typography gutterBottom>
                <strong>Type :</strong> Particulier
                </Typography>
                <Typography gutterBottom>
                <strong>Nom :</strong> {props.client.client_firstname}
                </Typography>
                <Typography gutterBottom>
                <strong>Prénom :</strong> {props.client.client_lastname}
                </Typography>
                <Typography gutterBottom>
                <strong>Téléphone :</strong> {props.client.client_tel}
                </Typography>
                <Typography gutterBottom>
                <strong>Adress :</strong> {props.client.client_address}
                </Typography>
                <Typography gutterBottom>
                <strong>Ville :</strong> {props.client.client_city}
                </Typography>
                <Typography gutterBottom>
                <strong>Pays :</strong> {props.client.client_country}
                </Typography>
            </>}
        </Box>
    );
}

export default ClientInfo;